export default "__VITE_ASSET__CdZWdE0G__"